import React from "react";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";

function AuctionCard() {
  const exploreData = [
    {
      expSrc: "./Assets/auction_2.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_3.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_4.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_5.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_6.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_7.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_8.png",
      bidPrice: "19.4 ETH",
    },
    {
      expSrc: "./Assets/auction_9.png",
      bidPrice: "19.4 ETH",
    },
  ];
  return (
    <div>
      {" "}
      {/* Grid For headings */}
      <Grid
        container
        sx={{
          justifyContent: {
            xs: "center",
            sm: "center",
            lg: "space-between",
          },
        }}
        alignItems="center"
      >
        <Grid item xs={5} sm={11} lg={6}>
          <h1 className="head_h">hot bids</h1>
        </Grid>
      </Grid>
      {/* GRID FOR EXPLORE CARD */}
      <div className="seprator"></div>
      <Grid container justifyContent="space-between">
        {exploreData.map((e) => {
          return (
            <Grid item xs={12} sm={6} lg={2.9}>
              <Link to="/itemdetail" className="links">
                <div className="explore_card">
                  <img src={e.expSrc} alt="photos" className="img_width" />
                  <div className="explore_card_content">
                    <div className="r_card_content">
                      <p className="e_p">19.4 ETH</p>
                      <p>Highest Bid</p>
                    </div>
                    <Link to="/auction">
                      <button className="common_btn_three">place bid</button>
                    </Link>
                  </div>
                </div>
              </Link>
            </Grid>
          );
        })}
      </Grid>
      <div className="explore_last_btn">
        <button className="view_all">View all Items</button>
      </div>
    </div>
  );
}

export default AuctionCard;
